import { createSelector } from 'reselect';

import type { RootState } from '../.';

export const selectWizard = (state: RootState) => state.wizard;

export const selectWizardCurrentStep = createSelector(
  selectWizard,
  (wizard) => wizard.currentStep,
);

export const selectSelectedTimePeriod = createSelector(
  selectWizard,
  (wizard) => wizard.datePickerTabMenu.selected.timePeriod,
);

export const selectActiveTimePeriod = createSelector(
  selectWizard,
  (wizard) => wizard.datePickerTabMenu.active.timePeriod,
);

export const selectDateInNYCToday = createSelector(
  selectWizard,
  (wizard) => wizard.dateInNYCToday,
);

export const selectWizardDatePicker = createSelector(
  selectWizard,
  (wizard) => wizard.datePicker,
);

export const selectIsAdvancingMonths = createSelector(
  selectWizard,
  (wizard) => wizard.isAdvancingMonths,
);

export const selectCounterEndTime = createSelector(
  selectWizard,
  (wizard) => wizard.counterEndTime,
);

export const selectCancelRunningQueries = createSelector(
  selectWizard,
  (wizard) => wizard.cancelRunningQueries,
);

export const selectIsCountdownActive = createSelector(
  selectWizard,
  (wizard) => {
    const date = new Date().getTime();

    return wizard.counterEndTime ? wizard.counterEndTime > date : false;
  },
);
